import React, { createContext, useContext, useState } from 'react';

const GovernanceLangContext = createContext({ lang: 'pt', setLang: () => {} });

export const GovernanceLangProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem('vukz_gov_lang') || 'pt'
  );

  const setLang = (l) => {
    localStorage.setItem('vukz_gov_lang', l);
    setLangState(l);
  };

  return (
    <GovernanceLangContext.Provider value={{ lang, setLang }}>
      {children}
    </GovernanceLangContext.Provider>
  );
};

export const useGovernanceLang = () => useContext(GovernanceLangContext);

export default GovernanceLangContext;
